//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { mapGetters } from 'vuex'
import DateIntervalField from '../../components/Field/DateIntervalField.vue'

export default {
  name: 'EmployeePropertyWorkAreaScheduleEdit',
  components: {
    DateIntervalField
  },
  props: {
    workAreaSchedule: {
      type: Object,
      default: null
    },
    employeeWorkArea: {
      type: Array,
      default: []
    }
  },
  data: function () {
    return {
      record: {
        interval: this.getDefaultInterval(),
        workShift: true,
        workAreas: [],
        comment: ''
      },

      workAreas: [],
      loading: false,
      opened: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  watch: {
    opened: function (result) {
      if (!result) {
        this.resetParameters()
      } else {
        this.loadWorkAreas()
      }
    }
  },
  methods: {
    onSave: function () {
      if (!this.workAreaSchedule.startTime) {
        this.$set(this.workAreaSchedule, 'startTime', [])
        this.$set(this.workAreaSchedule, 'endTime', [])
        this.$set(this.workAreaSchedule, 'workAreas', [])
        this.$set(this.workAreaSchedule, 'workAreasIds', [])
        this.$set(this.workAreaSchedule, 'workAreasNames', [])
        this.$set(this.workAreaSchedule, 'comment', [])
        this.$set(this.workAreaSchedule, 'user', [])
        this.$set(this.workAreaSchedule, 'fio', [])
        this.$set(this.workAreaSchedule, 'workShift', [])
      }

      this.workAreaSchedule.startTime.push(this.record.interval.start)
      this.workAreaSchedule.endTime.push(this.record.interval.end - 1000)
      this.workAreaSchedule.workAreas.push(this.record.workAreas.map(workArea => workArea.key))
      this.workAreaSchedule.workAreasIds.push(this.record.workAreas.map(workArea => workArea.id))
      this.workAreaSchedule.workAreasNames.push(this.record.workAreas.map(workArea => workArea.name))
      this.workAreaSchedule.comment.push(this.record.comment)
      this.workAreaSchedule.user.push(this.user.login)
      this.workAreaSchedule.fio.push(this.user.name)
      this.workAreaSchedule.workShift.push(this.record.workShift)

      this.opened = false
    },
    resetParameters: function () {
      this.record.interval = this.getDefaultInterval()
      this.record.workAreas = []
      this.record.comment = ''
      this.record.workShift = true
    },
    loadWorkAreas: function () {
      this.loading = true
      axiosGet({
        url: '/service/obj/search?type=workArea&subtypes=true&page=1&start=0&limit=50&sort=name&dir=ASC',
        onSuccess: (response) => {
          const allWorkAreas = response.data.result
          const employeeWorkAreaKeys = this.employeeWorkArea.map(employeeWorkArea => employeeWorkArea.key)
          this.workAreas = allWorkAreas.filter((workArea) => !employeeWorkAreaKeys.includes(workArea.key))
        },
        onFailure: 'Ошибка получения направлений работ',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    getDefaultInterval: function () {
      const currentDate = new Date()
      currentDate.setHours(0, 0, 0, 0)
      const currentDateStartMillis = currentDate.getTime()
      return {
        start: currentDateStartMillis,
        end: currentDateStartMillis + 86400000
      }
    }
  }
}
